export function claimTourStart(state, activeTour) {
    if (activeTour || state.pending) {
        return false
    }

    state.pending = true

    return true
}

export function releaseTourStart(state) {
    state.pending = false
}

export function hasVisibleModal(document) {
    return [...document.querySelectorAll('[aria-modal="true"], .jetstream-modal, dialog[open]')]
        .some((modal) => modal.getClientRects().length > 0 && getComputedStyle(modal).visibility !== 'hidden')
}

export function requestedTourFromHash(hash) {
    return hash.match(/^#cpm-tour=([^&]+)/)?.[1] ?? null
}
